import { ShoppingBagPage } from './ShoppingBagPage';

export default ShoppingBagPage;
